/**
 * Checkout success handler
 * Clears cart and hides badge after successful payment
 */

(function() {
  var container = document.getElementById('checkout-success');
  if (!container) return;

  // Clear the cart
  if (typeof Cart !== 'undefined' && Cart.isAvailable()) {
    Cart.clear();
    console.log('Cart cleared after successful checkout');
  }

  // Update floating cart badge if it exists
  var badge = document.getElementById('floating-cart-badge');
  if (badge) {
    badge.style.display = 'none';
  }
})();
